module.exports = __webpack_public_path__ + "img/40_00_078_433.646156a4.jpg";